import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FORMS_SUBMISSION_DEPENDANT } from "@Shared/@Utils/constants";
import { capitalize } from "lodash";
import { defineComponent } from "@vue/composition-api";
import ApplicantSelect from "@Broker/@Modules/util-components/application/applicant-select.vue";
import CheckboxSection from "@Shared/components/sections/checkbox-section.vue";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "FormsTable",
  components: {
    CheckboxSection,
    ApplicantSelect
  },
  props: {
    documentForms: {
      type: Array,
      required: true
    },
    mortgageType: {
      type: String,
      required: true
    },
    selectAndPrintEnabled: {
      type: Boolean,
      required: true
    }
  },
  data() {
    var _context, _context2;
    return {
      formsTableColumns: ["select", "mortgage", "name", "actions"],
      labelValue: uuidv4(),
      selectedApplicants: _reduceInstanceProperty(_context = _filterInstanceProperty(_context2 = this.documentForms).call(_context2, e => e == null ? void 0 : e.applicantSelect)).call(_context, (acc, {
        formKey
      }) => _objectSpread(_objectSpread({}, acc), {}, {
        [formKey]: {
          value: [],
          all: true,
          locked: false
        }
      }), {})
    };
  },
  computed: {
    options() {
      return {
        filterable: false,
        sortable: [],
        showChildRowToggler: false,
        headings: {
          select: this.$t("global.words.select"),
          mortgage: this.$t("global.doorr.mortgage"),
          name: this.$t("global.words.form"),
          actions: this.$t("global.words.actions")
        },
        perPage: 999999,
        tabbable: false,
        skin: "table table-hover",
        columnsClasses: {
          select: "hidden-heading",
          actions: "w-25 hidden-heading"
        }
      };
    }
  },
  methods: {
    isFormSubmissionDependant(row) {
      if (_includesInstanceProperty(FORMS_SUBMISSION_DEPENDANT).call(FORMS_SUBMISSION_DEPENDANT, row.formKey)) return this.selectAndPrintEnabled;
      return true;
    },
    handlePrint(row) {
      var _this$selectedApplica;
      this.$emit("print", _objectSpread(_objectSpread({}, row), {}, {
        mortgageType: this.mortgageType,
        selectedApplicants: (_this$selectedApplica = this.selectedApplicants[row.formKey]) == null ? void 0 : _this$selectedApplica.value
      }));
    },
    handleEdit(row) {
      this.$emit("edit", _objectSpread(_objectSpread({}, row), {}, {
        mortgageType: this.mortgageType
      }));
    },
    handleSelectDocument(row, selected) {
      if (row != null && row.applicantSelect) this.selectedApplicants[row.formKey].locked = selected;
      if (!this.isFormSubmissionDependant(row)) return;
      this.$emit("select", {
        formKey: row.formKey,
        mortgageType: this.mortgageType
      });
    },
    getMortgageTitle(formKey) {
      if (formKey === "consentForm") return capitalize(this.$tc("filogix.deal", 1));
      if (formKey === "mortgageApplication") return `${capitalize(this.$t("application-form")[this.mortgageType])} ${this.$t("global.doorr.mortgage")}`;
      return "";
    },
    isMortgageSelected(mortgagesSelected) {
      return _includesInstanceProperty(mortgagesSelected).call(mortgagesSelected, this.mortgageType);
    },
    handleApplicantSelect(row, selectedApplicants) {
      this.selectedApplicants[row.formKey].value = selectedApplicants;
    },
    handleTotalApplicants({
      formKey
    }, total) {
      this.selectedApplicants[formKey].all = total === this.selectedApplicants[formKey].value.length;
    }
  }
});